import { render, staticRenderFns } from "./CommonMessage.vue?vue&type=template&id=a2974724&scoped=true"
import script from "./CommonMessage.vue?vue&type=script&lang=js"
export * from "./CommonMessage.vue?vue&type=script&lang=js"
import style0 from "./CommonMessage.vue?vue&type=style&index=0&id=a2974724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2974724",
  null
  
)

export default component.exports